<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Fuentes de financiamiento</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="name"
                        class="form-control"
                        placeholder="tipo de financiamiento"
                    />
                    <span v-if="allerrors.name" :class="['show-error']">{{
                        allerrors.name[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Agregar
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            action: "",
            name: null,
            allerrors: {
                name: null,
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/funding-source/show/" + me.model_id)
                .then(function (response) {
                    me.name = response.data.name;
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;
            if (me.validForm()) {
                axios
                    .post(me.action, {
                        name: me.name,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(me.action, {
                        name: me.name,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Actualizacion exitosa!");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.name) {
                me.allerrors.name = [
                    "El campo Fuentes de financiamiento es obligatorio.",
                ];
                valid = false;
            } else if (me.name.length > 60) {
                me.allerrors.name = [
                    "El campo Fuentes de financiamiento debe tener máximo 60 caraccteres",
                ];
                valid = false;
            } else {
                me.allerrors.name = null;
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                name: null,
            };
        },
    },

    mounted() {
        let me = this;
        const authUserId = document.querySelector('meta[name="x-user"]').content;
        if (me.model_id == 0) {
            me.action = `/api/funding-source?key=${authUserId}`;
        } else {
            this.getModel();
            me.action = "/api/funding-source/update/" + me.model_id;
        }
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
